import { CompositeScreenProps } from '@react-navigation/native'
import React from 'react'

import { FilledButton } from 'widgets/Button/FilledButton'
import { LoadingSpinner } from 'widgets/LoadingSpinner'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useGroup } from 'hooks/useGroup'

import { links } from 'utils/constants'

export const TrainerOnboardingFlow = ({
  navigation,
}: CompositeScreenProps<any, any>): JSX.Element => {
  const { data: currentUser } = useCurrentUser()
  const { meta } = useGroup({ userId: currentUser?.id })

  const { hasSetupGroup } = meta

  const openUpspaceSettings = () => {
    navigation.navigate(links.UPSPACE_SETTINGS_PAGE)
  }

  return hasSetupGroup ? (
    <FilledButton title='My Group Settings' onPress={openUpspaceSettings} />
  ) : (
    <LoadingSpinner />
  )
}
